import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";

interface CouponWarehouseListState {
    couponwarehouselist: {
    load: boolean;
    data: [];
  };
}

export const CouponWarehouseListSlice = createSlice({
  name: "couponwarehouselist",
  initialState: {
    couponwarehouselist: {
      load: false,
      data: [],
    },
  } as CouponWarehouseListState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchCouponWarehouseList.pending, (state: CouponWarehouseListState) => {
        state.couponwarehouselist.load = true;
      })
      .addCase(fetchCouponWarehouseList.fulfilled, (state: CouponWarehouseListState, action: any) => {
        state.couponwarehouselist.data = action.payload;
        state.couponwarehouselist.load = false;
      })
      .addCase(fetchCouponWarehouseList.rejected, (state: CouponWarehouseListState) => {
        state.couponwarehouselist.load = false;
      });
  },
});

export default CouponWarehouseListSlice.reducer;

export const fetchCouponWarehouseList = createAsyncThunk(
    "couponwarehouselist/fetchCouponWarehouseList",
    async (param: { apiParam: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post("api/getClientList", {
              coupon_code: param.apiParam.couponCode
            });
            thunkAPI.dispatch(toggleLoading());
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    }
);
